import { render, staticRenderFns } from "./officialWebsiteAlert.vue?vue&type=template&id=238d30a6&scoped=true"
import script from "./officialWebsiteAlert.vue?vue&type=script&lang=js"
export * from "./officialWebsiteAlert.vue?vue&type=script&lang=js"
import style0 from "./officialWebsiteAlert.vue?vue&type=style&index=0&id=238d30a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d30a6",
  null
  
)

export default component.exports